/**
 * @generated SignedSource<<1dd8ab49c2444dac3652f96c07004db2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCheckSuperTopic$data = {
  readonly types: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly " $fragmentType": "topicCheckSuperTopic";
};
export type topicCheckSuperTopic$key = {
  readonly " $data"?: topicCheckSuperTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCheckSuperTopic">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "topicCheckSuperTopic"
};

(node as any).hash = "f7f7bbcc084b0870895bcae7f65cfcdc";

export default node;
